module.exports = __webpack_public_path__ + "static/img/product_images_28_h5_zh.35d55e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_28_h5_zh.png
// module id = phO1
// module chunks = 34